import {
  Clock,
  CheckCircle,
  Bot,
  Timer,
  TrendingUp,
  TrendingDown,
  Smartphone,
  Laptop,
  Wrench,
} from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Button } from "../../components/ui/button";
function Dashboard({ onViewClaims }) {
  const statsCards = [
    {
      title: "Pending Claims",
      value: 12,
      icon: Clock,
      iconColor: "text-white",
      bgColor: "bg-warning bg-opacity-10",
      trend: "+12%",
      trendDirection: "up",
      trendLabel: "vs last week",
    },
    {
      title: "Resolved Today",
      value: 8,
      icon: CheckCircle,
      iconColor: "text-white",
      bgColor: "bg-success bg-opacity-10",
      trend: "+8%",
      trendDirection: "up",
      trendLabel: "vs yesterday",
    },
    {
      title: "AI Accuracy",
      value: "96%",
      icon: Bot,
      iconColor: "text-white",
      bgColor: "bg-info bg-opacity-10",
      trend: "+2.1%",
      trendDirection: "up",
      trendLabel: "this month",
    },
    {
      title: "Avg Resolution",
      value: "2.5h",
      icon: Timer,
      iconColor: "text-white",
      bgColor: "bg-comerco-primary bg-opacity-10",
      trend: "-0.3h",
      trendDirection: "down",
      trendLabel: "improvement",
    },
  ];

  const recentClaims = [
    {
      claimId: "CLM12345",
      planId: "laptop-protection",
      status: "pending",
      issueType: "screen_damage",
      claimedAmount: 129.99,
      createdAt: new Date().toISOString(),
    },
    {
      claimId: "CLM12346",
      planId: "phone-protection",
      status: "approved",
      issueType: "water_damage",
      claimedAmount: 89.99,
      createdAt: new Date().toISOString(),
    },
    {
      claimId: "CLM12347",
      planId: "headphone-plan",
      status: "under_review",
      issueType: "battery_issue",
      claimedAmount: 49.99,
      createdAt: new Date().toISOString(),
    },
  ];
  const getDeviceIcon = (planId) => {
    if (planId?.includes("laptop")) return <Laptop size={20} />;
    if (planId?.includes("phone")) return <Smartphone size={20} />;
    return <Wrench size={20} />;
  };
  return (
    <div className="space-y-8">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statsCards.map((stat) => {
          const Icon = stat.icon;
          const TrendIcon =
            stat.trendDirection === "up" ? TrendingUp : TrendingDown;

          return (
            <Card key={stat.title} className="shadow-sm">
              <CardContent className="!p-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-slate-600">
                      {stat.title}
                    </p>
                    <p className="text-3xl font-bold text-slate-900">
                      {stat.value}
                    </p>
                  </div>
                  <div
                    className={`w-12 h-12 ${stat.bgColor} rounded-lg flex items-center justify-center`}
                  >
                    <Icon className={stat.iconColor} size={24} />
                  </div>
                </div>
                <div className="mt-4 flex items-center gap-2">
                  <span
                    className={`text-sm flex items-center gap-1 ${
                      stat.trendDirection === "up"
                        ? "text-success"
                        : "text-error"
                    }`}
                  >
                    <TrendIcon size={14} />
                    {stat.trend}
                  </span>
                  <span className="text-sm text-slate-500">
                    {stat.trendLabel}
                  </span>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="shadow-sm">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="text-lg">Recent Claims</CardTitle>
            <Button
              variant="link"
              className="text-comerco-primary hover:text-blue-700"
              onClick={onViewClaims}
            >
              View all claims
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {recentClaims.slice(0, 3).map((claim) => (
              <div
                key={claim.claimId}
                className="flex items-center gap-4 p-4 bg-slate-50 rounded-lg hover:bg-slate-100 cursor-pointer transition-colors"
              >
                <div className="w-10 h-10 bg-comerco-primary rounded-lg flex items-center justify-center">
                  <span className="text-white" style={{ opacity: 0.8 }}>
                    {getDeviceIcon(claim.planId)}
                  </span>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold text-slate-900">
                      {claim.claimId}
                    </h3>
                    <span
                      className={`px-2 py-1 text-xs rounded-full ${
                        claim.status === "pending" ||
                        claim.status === "under_review"
                          ? "bg-warning text-white"
                          : claim.status === "approved"
                          ? "bg-success text-white"
                          : "bg-info text-white"
                      }`}
                    >
                      {claim.status === "under_review"
                        ? "Pending Review"
                        : claim.status === "approved"
                        ? "AI Approved"
                        : claim.status}
                    </span>
                  </div>
                  <p className="text-sm text-slate-600">
                    {claim.issueType?.replace("_", " ")} issue
                  </p>
                  <p className="text-xs text-slate-500">
                    Customer: john.doe@email.com
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-medium text-slate-900">
                    ${claim.claimedAmount}
                  </p>
                  <p className="text-xs text-slate-500">
                    {new Date(claim.createdAt).toLocaleTimeString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
export default Dashboard;
